export const Collections = {
  users: 'users',
  publicProfiles: 'publicProfiles',
  userGroups: 'userGroups',
  properties: 'properties',
  listings: 'listings',
  listingTerms: 'listingTerms',
  leaseAgreements: 'leaseAgreements',
  showings: 'showings',
  appointments: 'appointments',
  tenantProfiles: 'tenantProfiles',
  leaseInvites: 'leaseInvites',
  rentApplications: 'rentApplications',
  conversations: 'conversations',
  messages: 'messages',
  creditReports: 'creditReports',
  bookmarks: 'bookmarks',
  ratingsAndReviews: 'ratingsAndReviews',
  bankAccounts: 'bankAccounts',
  idVerifications: 'idVerifications',
  wallets: 'wallets',
  prospectiveTenants: 'prospectiveTenants',
  invites: 'invites',
  leaseAgreementTenantInvites: 'tenantInvites',
  leaseAgreementDocuments: 'documents',
  leaseAgreementRequestDocuments: 'requests',
  reviews: 'reviews',
  backgroundCheckConsent: 'backgroundCheckConsent',
  bills: 'bills',
  trxLogs: 'transactionLogs',
  creditReportSeats: 'creditReportSeats'
};

type ConstraintOp = '<' | '<=' | '==' | '!=' | '>=' | '>' | 'in' | 'array-contains';
export interface QueryOperation {
  type: 'where' | 'limit' | 'orderBy' | 'startAfter' | 'or' | 'and';
}

type FilterQueryOperation = WhereQueryOperation | AndQueryOperation | OrQueryOperation;
export class WhereQueryOperation implements QueryOperation {
  readonly type = 'where';
  constructor(public field: string, public op: ConstraintOp, public value: any) { }
}

export class StartAfterQueryOperation implements QueryOperation {
  readonly type = 'startAfter';
  constructor(public value: any) { }
}

export class LimitQueryOperation implements QueryOperation {
  readonly type = 'limit';
  constructor(public number: number) { }
}

export class OrderByQueryOperation implements QueryOperation {
  readonly type = 'orderBy';
  constructor(public field: string, public direction: 'desc' | 'asc') { }
}

export class OrQueryOperation implements QueryOperation {
  readonly type = 'or';
  constructor(public value: FilterQueryOperation[]) { }
}

export class AndQueryOperation implements QueryOperation {
  readonly type = 'and';
  constructor(public value: FilterQueryOperation[]) { }
}

export abstract class DBStore { }
